export default __webpack_public_path__ + "static/media/skeleton1.f9cb16e2.png";